module.exports = __webpack_public_path__ + "img/cardsample.4790c43c.png";